import React from 'react';
import GenerateCss from '../functions/GenerateCss.jsx';
import useSyncCompiledCss from '../hooks/useSyncCompiledCss.jsx';

function Style( { attributes, blockId, setAttributes } ) {
	const unique = blockId
		? `.wp-block-alpha-blocks-buttons.block-${ blockId }`
		: '.wp-block-alpha-blocks-buttons';
	const {
		contentAlignment,
		contentVerticalAlignment,
		buttonAlignment,
		maxContentWidth,
		minHeight,
		margin,
		padding,
		border,
		borderRadius,
		containerBackground,
		containerShadow,
		columnGap,
	} = attributes;

	const CssObj = {
		[ unique ]: [
			GenerateCss.css( 'display', 'flex' ),
			GenerateCss.css(
				'flex-direction',
				buttonAlignment === 'vertical' ? 'column' : 'row'
			),
			GenerateCss.css( 'justify-content', contentAlignment ),
			GenerateCss.css( 'align-items', contentVerticalAlignment ),
			GenerateCss.lengthProp( 'max-width', maxContentWidth ),
			GenerateCss.lengthProp( 'min-height', minHeight ),
			GenerateCss.lengthProp( 'column-gap', columnGap ),
			GenerateCss.margin( margin ),
			GenerateCss.padding( padding ),
			GenerateCss.border( border ),
			GenerateCss.borderRadius( borderRadius ),
			GenerateCss.background( containerBackground ),
			GenerateCss.boxShadow( containerShadow ),
		],
	};

	const compiledCss = GenerateCss.CompiledCss( CssObj );

	useSyncCompiledCss( compiledCss, setAttributes );

	return <style>{ compiledCss }</style>;
}

export default Style;
